package org.vreo.devicehub.features.device.presentation.components

import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.product_type_volt_s1_bollard
import devicehub.composeapp.generated.resources.product_type_volt_s1_pole_lr
import devicehub.composeapp.generated.resources.product_type_volt_s1_pole_sr
import devicehub.composeapp.generated.resources.product_type_volt_s1_wall_mount

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.core.domain.device.device.ProductType

/**
 * Convert [ProductType] to [UiText].
 *
 * @return [UiText] on success, error otherwise
 */
fun ProductType.toUiText(): UiText {
    val stringRes = when (this) {
        ProductType.VoltS1PoleShortRange -> Res.string.product_type_volt_s1_pole_sr
        ProductType.VoltS1PoleLongRange -> Res.string.product_type_volt_s1_pole_lr
        ProductType.VoltS1Bollard -> Res.string.product_type_volt_s1_bollard
        ProductType.VoltS1WallMount -> Res.string.product_type_volt_s1_wall_mount
    }

    return UiText.StringResourceId(stringRes)
}